import { createStackNavigator } from "@react-navigation/stack";
import React, { useContext } from "react";
import BankAccount from "../views/BankAccount";
import BankAccountPix from "../views/BankAccountPix";
import BankSlip from "../views/BankSlip";
import BarCodeConfirmPay from "../views/BarCodeConfirmPay";
import BarCodePay from "../views/BarCodePay";
import BuyExchange from "../views/BuyExchange";
import BuyToken from "../views/BuyToken";
import Cashback from "../views/Cashback";
import Certificates from "../views/Certificates";
import CertificatesEmit from "../views/CertificatesEmit";
import ChangePassword from "../views/ChangePassword";
import ConfirmPaperWallet from "../views/ConfirmPaperWallet";
import ConfirmPassword from "../views/ConfirmPassword";
import ConfirmPasswordPaperWallet from "../views/ConfirmPasswordPaperWallet";
import ConfirmPasswordPurchaseOrSell from "../views/ConfirmPasswordPurchaseOrSell";
import ConfirmPasswordTransfer from "../views/ConfirmPasswordTransfer";
import ConfirmPurchase from "../views/ConfirmPurchase";
import ConfirmPurchaseOrSell from "../views/ConfirmPurchaseOrSell";
import ConfirmSearchUser from "../views/ConfirmSearchUser";
import ConfirmSearchUserSell from "../views/ConfirmSearchUserSell";
import ConfirmSell from "../views/ConfirmSell";
import ConfirmTransfer from "../views/ConfirmTransfer";
import CreditCardPayment from "../views/CreditCardPayment";
import DeleteAccount from "../views/DeleteAccount";
import DeleteCard from "../views/DeleteCard";
import DepositBoleto from "../views/DepositBoleto";
import DepositCreditCard from "../views/DepositCreditCard";
import DepositCreditCardSummary from "../views/DepositCreditCardSummary";
import DepositCrypto from "../views/DepositCrypto";
import DepositCryptoSelection from "../views/DepositCryptoSelection";
import DepositGPXAmount from "../views/DepositGPXAmount";
import DepositMethod from "../views/DepositMethod";
import DepositNewCreditCard from "../views/DepositNewCreditCard";
import DepositPaymentMethod from "../views/DepositPaymentMethod";
import DepositPix from "../views/DepositPix";
import DetailsCoin from "../views/DetailsCoin";
import EditBankAccount from "../views/EditBankAccount";
import EditCard from "../views/EditCard";
import EmailPix from "../views/EmailPix";
import Exchange from "../views/Exchange";
import Home from "../views/Home";
import IdentityDocumentPix from "../views/IdentityDocumentPix";
import IncomeVoucher from "../views/IncomeVoucher";
import InvestorProfile from "../views/InvestorProfile";
import LevelUpdate from "../views/LevelUpdate";
import Marketplace from "../views/Marketplace";
import MarketplaceCategories from "../views/MarketplaceCategories";
import MoreInfosCoin from "../views/MoreInfosCoin";
import MyAccount from "../views/MyAccount";
import MyBalance from "../views/MyBalance";
import MyCards from "../views/MyCards";
import MyQualification from "../views/MyQualification";
import NewBankAccount from "../views/NewBankAccount";
import NewCard from "../views/NewCard";
import NewPassword from "../views/NewPassword";
import PaperWallet from "../views/PaperWallet";
import PaperWalletDeposit from "../views/PaperWalletDeposit";
import PaymentMethod from "../views/PaymentMethod";
import PaymentMethodPay from "../views/PaymentMethodPay";
import PaymentMethodSell from "../views/PaymentMethodSell";
import PaymentMethodTransfer from "../views/PaymentMethodTransfer";
import PhonePix from "../views/PhonePix";
import Purchase from "../views/Purchase";
import PurchaseMkt from "../views/PurchaseMkt";
import QrCodeConfirmPay from "../views/QrCodeConfirmPay";
import QrCodeConfirmTransferPix from "../views/QrCodeConfirmTransferPix";
import QrCodePay from "../views/QrCodePay";
import QrCodeTransferPix from "../views/QrCodeTransferPix";
import RandomKeyPix from "../views/RandomKeyPix";
import ReportIncome from "../views/ReportIncome";
import SearchUsers from "../views/SearchUsers";
import SelectPixKey from "../views/SelectPixKey";
import Sell from "../views/Sell";
import SellExchange from "../views/SellExchange";
import Tabs from "../views/Tabs";
import TermsService from "../views/TermsService";
import Token from "../views/Token";
import Transfer from "../views/Transfer";
import TransferFindUser from "../views/TransferFindUser";
import UpdateRegistration from "../views/UpdateRegistration";
import WithdrawCrypto from "../views/WithdrawCrypto";
import WithdrawCryptoPassword from "../views/WithdrawCryptoPassword";
import WithdrawCryptoSelection from "../views/WithdrawCryptoSelection";
import WithdrawGPX from "../views/WithdrawGPX";
import WithdrawGPXAccountSelection from "../views/WithdrawGPXAccountSelection";
import WithdrawGPXPassword from "../views/WithdrawGPXPassword";
import WithdrawMethod from "../views/WithdrawMethod";
import Login from "../views/login";
import Register from "../views/register";
import Welcome from "../views/welcome";
import pt from "../i18n/translations.pt-BR.json";
import it from "../i18n/translations.it.json";
import en from "../i18n/translations.en.json";
import { IntlProvider } from "react-intl";
import NavBarGlobal from "../views/NavBarGlobal";
import Wallet from "../views/Wallet";
import IframeScreen from "../components/IframeScreen/IframeScreen";
import StripeCreditCard from "../views/StripeCreditCard";
import DepositBankAccount from "../views/DepositBankAccount";
import { LanguageContext } from "../context/LanguageContext";
import Traceability from "../views/Traceability";
import StampsCalculator from "../views/StampsCalculator";
import AssetsOwnership from "../views/AssetsOwnership";
import ExtratoView from "../views/ExtratoView";
const stackRoutes = createStackNavigator();

const PageRoutes = () => {
  const translations = {
    "pt-BR": pt,
    it,
    en,
  };

  const { lang } = useContext(LanguageContext);

  // Defina o estilo padrão para o navigator
  const defaultNavigatorOptions = {
    headerShown: true,
    header: () => <NavBarGlobal />,
    cardStyle: {
      backgroundColor: "#FFFFFF", // Cor de fundo padrão
    },
  };

  return (
    <IntlProvider
      messages={translations[lang]}
      locale="pt-BR"
      defaultLocale="pt-BR"
    >
      <stackRoutes.Navigator
        initialRouteName={
          window.location.href.toLowerCase().indexOf("register") === -1
            ? window.location.href.toLowerCase().indexOf("login") === -1
              ? "Welcome"
              : "Login"
            : "Register"
        }
        headerMode="screen"
        screenOptions={defaultNavigatorOptions}
      >
        <stackRoutes.Screen
          name="Welcome"
          component={Welcome}
          options={{ headerShown: false, title: "Bem-vindo" }}
        />
        <stackRoutes.Screen
          name="Login"
          component={Login}
          options={{ headerShown: false, title: "Entrar" }}
        />
        <stackRoutes.Screen
          name="Register"
          component={Register}
          options={{ headerShown: false, title: "Cadastro" }}
        />
        <stackRoutes.Screen
          name="TermsService"
          component={TermsService}
          options={{ headerShown: false }}
        />
        <stackRoutes.Screen
          name="Home"
          component={Home}
          options={{ title: "Início" }}
        />
        <stackRoutes.Screen
          name="MyAccount"
          component={MyAccount}
          options={{ title: "Minha conta" }}
        />
        <stackRoutes.Screen
          name="Tabs"
          component={Home}
          options={{ title: "Home" }}
        />
        <stackRoutes.Screen
          name="UpdateRegistration"
          component={UpdateRegistration}
          options={{ title: "Atualizar cadastro" }}
        />
        <stackRoutes.Screen
          name="ReportIncome"
          component={ReportIncome}
          options={{ title: "Declarar renda" }}
        />
        <stackRoutes.Screen
          name="DeleteAccount"
          component={DeleteAccount}
          options={{ title: "Excluir conta" }}
        />
        <stackRoutes.Screen
          name="IncomeVoucher"
          component={IncomeVoucher}
          options={{ title: "Voucher" }}
        />
        <stackRoutes.Screen
          name="Exchange"
          component={Exchange}
          options={{ title: "Exchange" }}
        />
        <stackRoutes.Screen
          name="Marketplace"
          component={MarketplaceCategories}
          options={{ title: "Marketplace" }}
        />
        <stackRoutes.Screen
          name="Wallet"
          component={Wallet}
          options={{ title: "Wallet" }}
        />
        <stackRoutes.Screen
          name="WalletEndorser"
          component={Wallet}
          initialParams={{ endorser: true }}
          options={{ title: "Wallet" }}
        />
        <stackRoutes.Screen
          name="Token"
          component={Token}
          options={{ title: "Marketplace" }}
        />
        <stackRoutes.Screen
          name="BankAccount"
          component={BankAccount}
          options={{ title: "Conta bancária" }}
        />
        <stackRoutes.Screen
          name="NewBankAccount"
          component={NewBankAccount}
          options={{ title: "Adicionar conta bancária" }}
        />
        <stackRoutes.Screen
          name="EditBankAccount"
          component={EditBankAccount}
          options={{ title: "Editar conta bancária" }}
        />
        <stackRoutes.Screen
          name="ChangePassword"
          component={ChangePassword}
          options={{ title: "Trocar senha" }}
        />
        <stackRoutes.Screen
          name="NewPassword"
          component={NewPassword}
          options={{ title: "Nova senha" }}
        />
        <stackRoutes.Screen
          name="MyCards"
          component={MyCards}
          options={{ title: "Meus cartões" }}
        />
        <stackRoutes.Screen
          name="NewCard"
          component={NewCard}
          options={{ title: "Adicionar cartão" }}
        />
        <stackRoutes.Screen
          name="EditCard"
          component={EditCard}
          options={{ title: "Editar cartão" }}
        />
        <stackRoutes.Screen
          name="DeleteCard"
          component={DeleteCard}
          options={{ title: "Deletar cartão" }}
        />
        <stackRoutes.Screen
          name="MarketplaceCategories"
          component={Marketplace}
          options={{ title: "Marketplace - categorias" }}
        />

        <stackRoutes.Screen
          name="DetailsCoin"
          component={DetailsCoin}
          options={{ title: "Detalhes da moeda" }}
        />
        <stackRoutes.Screen
          name="MoreInfosCoin"
          component={MoreInfosCoin}
          options={{ title: "Mais informações" }}
        />
        <stackRoutes.Screen
          name="MyBalance"
          component={MyBalance}
          options={{ title: "Meu saldo" }}
        />
        <stackRoutes.Screen
          name="ConfirmPassword"
          component={ConfirmPassword}
          options={{ title: "Confirmar senha" }}
        />
        <stackRoutes.Screen
          name="ConfirmPasswordPurchaseOrSell"
          component={ConfirmPasswordPurchaseOrSell}
          options={{ title: "Confirmar senha" }}
        />
        <stackRoutes.Screen
          name="ConfirmPasswordTransfer"
          component={ConfirmPasswordTransfer}
          options={{ title: "Confirmar senha" }}
        />
        <stackRoutes.Screen
          name="SellExchange"
          component={SellExchange}
          options={{ title: "Exchange - vender" }}
        />
        <stackRoutes.Screen
          name="ConfirmSell"
          component={ConfirmSell}
          options={{ title: "Confirmar venda" }}
        />
        <stackRoutes.Screen
          name="Purchase"
          component={Purchase}
          options={{ title: "Comprar" }}
        />
        <stackRoutes.Screen
          name="ConfirmPurchase"
          component={ConfirmPurchase}
          options={{ title: "Confirmar compra" }}
        />
        <stackRoutes.Screen
          name="ConfirmPurchaseOrSell"
          component={ConfirmPurchaseOrSell}
          options={{ title: "Confirmar transação" }}
        />
        <stackRoutes.Screen
          name="ConfirmTransfer"
          component={ConfirmTransfer}
          options={{ title: "Confirmar transferência" }}
        />
        <stackRoutes.Screen
          name="PaymentMethod"
          component={PaymentMethod}
          options={{ title: "Método de pagamento" }}
        />
        <stackRoutes.Screen name="BankSlip" component={BankSlip} />
        <stackRoutes.Screen
          name="CreditCardPayment"
          component={CreditCardPayment}
          options={{ title: "Pagamento com cartão de crédito" }}
        />
        <stackRoutes.Screen
          name="Transfer"
          component={Transfer}
          options={{ title: "Transferência" }}
        />
        <stackRoutes.Screen
          name="TransferFindUser"
          component={TransferFindUser}
          options={{ title: "Transferência - Buscar usuário" }}
        />
        <stackRoutes.Screen
          name="PaymentMethodTransfer"
          component={PaymentMethodTransfer}
          options={{ title: "Transferência - Método de pagamento" }}
        />
        <stackRoutes.Screen
          name="SearchUsers"
          component={SearchUsers}
          options={{ title: "Buscar usuários" }}
        />
        <stackRoutes.Screen
          name="ConfirmSearchUser"
          component={ConfirmSearchUser}
          options={{ title: "Transferência - Método de pagamento" }}
        />
        <stackRoutes.Screen
          name="SelectPixKey"
          component={SelectPixKey}
          options={{ title: "Pix - Selecionar chave" }}
        />
        <stackRoutes.Screen
          name="PhonePix"
          component={PhonePix}
          options={{ title: "Pix - Telefone" }}
        />
        <stackRoutes.Screen
          name="EmailPix"
          component={EmailPix}
          options={{ title: "Pix - E-mail" }}
        />
        <stackRoutes.Screen
          name="IdentityDocumentPix"
          component={IdentityDocumentPix}
          options={{ title: "Pix - Documento de identidade" }}
        />
        <stackRoutes.Screen
          name="RandomKeyPix"
          component={RandomKeyPix}
          options={{ title: "Pix - Chave aleatória" }}
        />
        <stackRoutes.Screen
          name="BankAccountPix"
          component={BankAccountPix}
          options={{ title: "Pix - Conta bancária" }}
        />
        <stackRoutes.Screen
          name="QrCodeTransferPix"
          component={QrCodeTransferPix}
          options={{ title: "Pix - QRCode" }}
        />
        <stackRoutes.Screen
          name="QrCodeConfirmTransferPix"
          component={QrCodeConfirmTransferPix}
          options={{ title: "Pix - Confirmar QRCode" }}
        />
        <stackRoutes.Screen
          name="PaymentMethodPay"
          component={PaymentMethodPay}
          options={{ title: "Pay - Método de pagamento" }}
        />
        <stackRoutes.Screen
          name="QrCodePay"
          component={QrCodePay}
          options={{ title: "Pay - QRCode" }}
        />
        <stackRoutes.Screen
          name="QrCodeConfirmPay"
          component={QrCodeConfirmPay}
          options={{ title: "Pay -  Confirmar QRCode" }}
        />
        <stackRoutes.Screen
          name="BarCodePay"
          component={BarCodePay}
          options={{ title: "Pay - Código de barras" }}
        />
        <stackRoutes.Screen
          name="BarCodeConfirmPay"
          component={BarCodeConfirmPay}
          options={{ title: "Pay - Confirmar código de barras" }}
        />
        <stackRoutes.Screen
          name="Sell"
          component={Sell}
          options={{ title: "Venda" }}
        />
        <stackRoutes.Screen
          name="PaymentMethodSell"
          component={PaymentMethodSell}
          options={{ title: "Venda - Método de pagamento" }}
        />
        <stackRoutes.Screen
          name="ConfirmSearchUserSell"
          component={ConfirmSearchUserSell}
          options={{ title: "Confirmar usuário" }}
        />
        <stackRoutes.Screen
          name="Cashback"
          component={Cashback}
          options={{ title: "Cashback" }}
        />
        <stackRoutes.Screen
          name="MyQualification"
          component={MyQualification}
          options={{ title: "Qualificação" }}
        />
        <stackRoutes.Screen
          name="LevelUpdate"
          component={LevelUpdate}
          options={{ title: "Atualização de nível" }}
        />
        <stackRoutes.Screen
          name="InvestorProfile"
          component={InvestorProfile}
          options={{ title: "Perfil do investidor" }}
        />
        <stackRoutes.Screen
          name="PurchaseMkt"
          component={PurchaseMkt}
          options={{ title: "Marketplace - comprar" }}
        />
        <stackRoutes.Screen
          name="Certificates"
          component={Certificates}
          options={{ title: "Certificado" }}
        />
        <stackRoutes.Screen
          name="CertificateEmit"
          component={CertificatesEmit}
          options={{ title: "Emitir certificado" }}
        />
        <stackRoutes.Screen
          name="BuyExchange"
          component={BuyExchange}
          options={{ title: "Exchange - comprar" }}
        />
        <stackRoutes.Screen
          name="BuyToken"
          component={BuyToken}
          options={{ title: "Comprar" }}
        />
        <stackRoutes.Screen
          name="DepositMethod"
          component={DepositMethod}
          options={{ title: "Método de depósito" }}
        />
        <stackRoutes.Screen
          name="DepositCryptoSelection"
          component={DepositCryptoSelection}
          options={{ title: "Selecionar - Depositar criptoativo" }}
        />
        <stackRoutes.Screen
          name="DepositCrypto"
          component={DepositCrypto}
          options={{ title: "Depósito criptoativo" }}
        />
        <stackRoutes.Screen
          name="DepositGPXAmount"
          component={DepositGPXAmount}
          options={{ title: "Depósito" }}
        />
        <stackRoutes.Screen
          name="DepositPaymentMethod"
          component={DepositPaymentMethod}
          options={{ title: "Depósito - método de pagamento" }}
        />
        <stackRoutes.Screen
          name="DepositPix"
          component={DepositPix}
          options={{ title: "Depósito - pix" }}
        />
        <stackRoutes.Screen
          name="DepositBoleto"
          component={DepositBoleto}
          options={{ title: "Depósito - boleto" }}
        />
        <stackRoutes.Screen
          name="DepositCreditCard"
          component={DepositCreditCard}
          options={{ title: "Depósito - cartão de crédito" }}
        />
        <stackRoutes.Screen
          name="DepositNewCreditCard"
          component={DepositNewCreditCard}
          options={{ title: "Depósito - novo cartão de crédito" }}
        />
        <stackRoutes.Screen
          name="DepositCreditCardSummary"
          component={DepositCreditCardSummary}
          options={{ title: "Depósito - detalhes do cartão de crédito" }}
        />
        <stackRoutes.Screen
          name="WithdrawMethod"
          component={WithdrawMethod}
          options={{ title: "Retirada - métodos de retirada" }}
        />
        <stackRoutes.Screen
          name="WithdrawGPXAccountSelection"
          component={WithdrawGPXAccountSelection}
          options={{ title: "Retirada - Selecionar conta" }}
        />
        <stackRoutes.Screen
          name="WithdrawGPX"
          component={WithdrawGPX}
          options={{ title: "Retirada - GPX" }}
        />
        <stackRoutes.Screen
          name="WithdrawCryptoSelection"
          component={WithdrawCryptoSelection}
          options={{ title: "Retirar - Selecionar Crypto" }}
        />
        <stackRoutes.Screen
          name="WithdrawCrypto"
          component={WithdrawCrypto}
          options={{ title: "Retirada - Crypto" }}
        />
        <stackRoutes.Screen
          name="WithdrawCryptoPassword"
          component={WithdrawCryptoPassword}
          options={{ title: "Retirada - Senha Crypto" }}
        />
        <stackRoutes.Screen
          name="WithdrawGPXPassword"
          component={WithdrawGPXPassword}
          options={{ title: "Retirada - Senha GPX" }}
        />
        <stackRoutes.Screen
          name="PaperWallet"
          component={PaperWallet}
          options={{ title: "Paper Wallet" }}
        />
        <stackRoutes.Screen
          name="DepositBankAccount"
          component={DepositBankAccount}
          options={{ title: "Deposit Bank Account" }}
        />
        <stackRoutes.Screen
          name="ConfirmPaperWallet"
          component={ConfirmPaperWallet}
          options={{ title: "Paper Wallet" }}
        />
        <stackRoutes.Screen
          name="ConfirmPasswordPaperWallet"
          component={ConfirmPasswordPaperWallet}
          options={{ title: "Paper Wallet" }}
        />
        <stackRoutes.Screen
          name="PaperWalletDeposit"
          component={PaperWalletDeposit}
          options={{ title: "Paper Wallet" }}
        />

        <stackRoutes.Screen
          name="StripeCreditCard"
          component={StripeCreditCard}
          options={{ title: "Credit Card" }}
        />

        <stackRoutes.Screen
          name="Traceability"
          component={Traceability}
          options={{ title: "Rastreabilidade" }}
        />

        <stackRoutes.Screen
          name="IframeScreen"
          component={IframeScreen}
          options={{ title: "Iframe" }}
        />

        <stackRoutes.Screen
          name="StampsCalculator"
          component={StampsCalculator}
          options={{ title: "Stamps Calculator" }}
        />
        <stackRoutes.Screen
          name="AssetsOwnership"
          component={AssetsOwnership}
          options={{ title: "AssetsOwnership" }}
        />
        <stackRoutes.Screen
          name="ExtratoView"
          component={ExtratoView}
          options={{ title: "Extrato de Ativos", headerShown: false }}
        />
      </stackRoutes.Navigator>
    </IntlProvider>
  );
};

export default PageRoutes;
